
import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  DOCUMENT
} from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Directiva principal usada para comprobar cuando se realiza el evento click fuera de un componente
 */
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[clickOutside]',
  standalone: false,
})
export class ClickOutsideDirective {
  /**
   * Evento output usado para emitir en el momento de detectar el evento click fuera del componente
   */
  @Output() clickOutside = new EventEmitter<void>();
  /**
   * Propiedad asignada para cuando se debe controlar que el componente debe o no recibir el evento enmitido por el output
   *
   * Existen componentes padre que tienen esta directiva pero no se pretende controlar cuando se ha relaizado el evento click fuera del hijo
   */
  @Input('isClickOutisdeEnabled')
  set isClickOutisdeEnabled(value: boolean) {
    this.isClickOutisdeEnabledSubject.next(value);
  }
  /**
   * Suscripción al evento de clic en el documento.
   * Se utiliza para detectar cuando se hace clic fuera del componente.
   */

  private isClickOutisdeEnabledSubject = new BehaviorSubject<boolean>(false);

  documentClickSubscription: Subscription | undefined;

  /**
   * Constructor de la clase.
   * @param element Referencia al elemento del componente en el DOM
   * @param document Referencia al objeto Document del DOM
   */
  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isClickOutisdeEnabledSubject.subscribe(enabled => {
      if (enabled) {
        this.documentClickSubscription = fromEvent(this.document, 'click')
          .pipe(filter((event) => !this.isInside(event.target as HTMLElement)))
          .subscribe(() => this.clickOutside.emit());
      } else {
        if (this.documentClickSubscription) this.documentClickSubscription.unsubscribe();
      }
    });
  }

  /**
   * Metodo que se ejecuta cuando se deja de utilizar el componente y realiza el unsubscribe
   */
  ngOnDestroy(): void {
    if (this.documentClickSubscription) { this.documentClickSubscription.unsubscribe(); }
    this.isClickOutisdeEnabledSubject.unsubscribe();
    this.clickOutside.unsubscribe();
  }

  /**
   * Comprueba si el elemento proporcionado está dentro del elemento nativo del componente.
   * @param elementToCheck Elemento HTML que se desea comprobar.
   * @returns Devuelve true si el elemento está dentro del elemento nativo del componente, de lo contrario, devuelve false.
   * @private
   */
  private isInside(elementToCheck: HTMLElement): boolean {
    return (
      elementToCheck === this.element.nativeElement ||
      this.element.nativeElement.contains(elementToCheck)
    );;
  }
}
